import { GenericDictionary } from "src/state/_types";
import { rrulestr } from 'rrule'

export const isObject = (item: any) => {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

export const mergeDeep = (target: { [index: string]: any }, ...sources: any): object => {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, {
                    [key]: {}
                });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, {
                    [key]: source[key]
                });
            }
        }
    }

    return mergeDeep(target, ...sources);
}


export const changeNullPropsDeep = (source: GenericDictionary, target: GenericDictionary = {}): object => {

    if (isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, {
                    [key]: {}
                });
                target[key] = changeNullPropsDeep(target[key], source[key]);
            } else {
                Object.assign(target, {
                    [key]: source[key] !== null ? source[key] : undefined
                });
            }
        }
    }

    return target;
}

export const changeEmptyPropsDeep = (source: GenericDictionary, target: GenericDictionary = {}) => {
    if (isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, {
                    [key]: {}
                });
                target[key] = changeEmptyPropsDeep(target[key], source[key]);
            } else {
                Object.assign(target, {
                    [key]: typeof source[key] === 'number' ? source[key] : typeof source[key] === 'boolean' ? source[key] : source[key] && source[key].length ? source[key] : null
                });
            }
        }
    }
    return target;
}

export const prettyRecurrence = (rruleString: string, startDate?: string) => {
    try {
        const rule = rrulestr(rruleString, {
            dtstart: startDate ? new Date(startDate) : undefined,
        })
        return rule.toText()    // -> "every 3 years until October 31, 2025"
    } catch (err) {
        console.error('Invalid RRULE', err)
        return 'Invalid recurrence rule'
    }
}

// Returns a shallow diff of fields that changed from prev -> next
export const getChangedFields = (prev: GenericDictionary, next: GenericDictionary): GenericDictionary => {
    const changed: GenericDictionary = {}
    const keys = Object.keys(next || {})

    for (const key of keys) {
        const prevValue = prev ? prev[key] : undefined
        const nextValue = next[key]
        if (prevValue !== nextValue) {
            changed[key] = nextValue
        }
    }

    return changed
}